<template>
  <v-container fluid style="height: 100%">
    <div class="bg">
      <v-row :class="$vuetify.breakpoint.mobile ? 'ma-5' : 'ma-5 d-flex justify-space-between'">
        <v-col class="py-0" cols="12">
          <v-container>

            <h2 style="color:#FFF;display: flex; justify-content:center;">Distribución de atenciones</h2>

          <div style="display:flex; flex-direction: column; align-items:center;">
            <div class="chart1">
            <div class="header-container" style="">
              <div>
            <v-select
            color="white"
              style="width: 200px !important;"
              :items="selectYear"
              label="Año"
              v-model="selectedYear"
            ></v-select>
              </div>
            <v-btn @click="exportExcel" color="primary">Descargar Listado de Atenciones</v-btn>
            </div>
              <Bar id="my-chart-id" :chartOptions="chartOptions1" :chartData="chartData1" />
            </div>
            <div class="chart1" style=" margin-top: 25px;">
            <h3 style=" margin-bottom: 20px; margin-top: 16px;;color:#FFF;display: flex; justify-content:center;">Distribución por materias</h3>
              <Bar id="my-chart-id2" :chartOptions="chartOptions2" :chartData="chartData2" />
            </div>
          </div>
          </v-container>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import exportToXLSX from "../../helpers/utils/excelExport.js"
import { getAppointmentsCharts, excelStats } from "../../helpers/api/horas_medicas.js";
import moment from "moment";
import { Bar } from 'vue-chartjs'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'
ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
  components: { Bar },
  data() {
    return {
      currentYear: moment().year(),
      selectYear: [],
      selectedYear: moment().year(),
      chartDataByDoctor: [],
      labelsByDoctor: [],
      chartData1: {
        labels: [],
        datasets: [
          { data: [], backgroundColor: '#f87979',
      }
        ]
      },
      chartOptions1: {
 scales: {
      xAxis: {
        ticks: {
          color: '#f87979'
        }
      },
      yAxis: {
        ticks: {
          color: '#f87979'
        }
      },
    },
        plugins: {
          legend: {
            display: false,
          }
        },
        responsive: true,
        maintainAspectRatio: true
      },
      chartData2: {
        labels: [],
        datasets: [
          { data: [], backgroundColor: '#f87979',
      }
        ]
      },
      chartOptions2: {
 scales: {
      xAxis: {
        ticks: {
          color: '#f87979'
        }
      }
      },
      yAxis: {
        ticks: {
          color: '#f87979'
        }
      },
        plugins: {
          legend: {
            display: false,
          }
        },
        responsive: true,
        maintainAspectRatio: true
      },
    }
  },
  methods: {
    getCharts() {
      const data = { anio: this.selectedYear };
      getAppointmentsCharts(data).then((res) => {
        this.chartData2.datasets[0].data = []
        this.chartData2.labels = []
        // valores select
        for (var i = res[0].min_year_1[0].min_year;i <= this.currentYear;i++) {
          this.selectYear.push(i);
        }
        // data chartByYear
        this.chartData1.datasets[0].data = Object.values(res[0].statistics_by_year[0]);
        this.chartData1.labels = Object.keys(res[0].statistics_by_year[0]);
        //data chartByDoctor

        res[1].statistics_people.forEach((item) => {
          this.chartData2.datasets[0].data.push(item.cantidad);
          this.chartData2.labels.push(item.materias);
        });
      });
    },
    exportExcel() {
      const data = { anio: this.selectedYear };
      excelStats(data).then(res => {
        exportToXLSX(res, `estadísticas-defensoría.xlsx`)
      })
    }
  },
  watch: {
     'selectedYear'(){
        this.getCharts();
    },
  },
  created() {
    this.getCharts();
  },
};
</script>

<style lang="scss" scoped>
@media (min-width: 850px) {
  .chart1 {
    width: 850px !important;
  }
}
.header-container {
  display: flex; justify-content: space-between; align-items:center;
}
@media (max-width: 568px) {
  .header-container {
    display: flex; 
    flex-direction: column;
    margin-top: 20px;
    margin-bottom: 20px;
  }
}

</style>
